<div class="just-flex">
	<ng-container>
		<ion-label>{{ displayValue }}</ion-label>
	</ng-container>
</div>